import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import DownloadIcon from '@mui/icons-material/Download';
import FormControl from '@mui/material/FormControl';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

function BulkPullsheetsForm(props) {

     return(
        <Box
        className={props.isMobile ? "mobile-box" : "desktop-box"}
        sx={{ display: 'flex', flexDirection: 'column', gap: 'px'  }}
      >
        {/* Acumatica Order Row */}
        <Box 
            className={props.isMobile ? "mobile-box" : "desktop-box"} 
            sx={{ flexDirection: 'row', mb: '20px' }}
        >
          <TextField
            name="acumaticaOrderNum"
            value={props.acumaticaOrderNum}
            label="Acumatica Order #"
            onChange={props.handleChange}
            sx={{ width: '20.2%', mr: '0.6%' }}
          />
          <Button
            onClick={props.createBulkPullsheet}
            endIcon={<DownloadIcon />}
            size="large"
            sx={{ mt: '10px', fontWeight: 'bold', color: '#84B375' }}
          >
            Download
          </Button>
        </Box>
  
        {/* Date Fields Row */}
        <Box 
            className={props.isMobile ? "mobile-box" : "desktop-box"} 
            sx={{ flexDirection: 'row', mb: '20px' }}
        >
          <FormControl sx={{ mr: '0.6%', width: '20%' }}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DatePicker
                label="Start Date"
                value={props.startDate || null}
                onChange={(val) => props.handleDateChange(val, 'startDate')}
              />
            </LocalizationProvider>
          </FormControl>
          <FormControl sx={{ mr: '0.6%', width: '20%' }}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DatePicker
                label="End Date"
                value={props.endDate || null}
                onChange={(val) => props.handleDateChange(val, 'endDate')}
              />
            </LocalizationProvider>
          </FormControl>
          <Button
            onClick={props.createBulkPullsheetFromDate}
            endIcon={<DownloadIcon />}
            size="large"
            sx={{ mt: '10px', fontWeight: 'bold', color: '#84B375' }}
          >
            Download
          </Button>
        </Box>
      </Box>
    );
}

export default BulkPullsheetsForm;